import React, { FC, useCallback } from 'react';
import { useNavigate } from 'react-router';

import Typography from '@mui/material/Typography';

import { useMediaQuery } from '@hooks/common/useMediaQuery';

import Button from '@components/common/Button';

import { PATH_INDEX } from '@constants/common/routes.constants';
import { Size } from '@constants/common/ui.constants';

import useStyles from './styles.module';

const NotFound: FC = () => {
  const navigate = useNavigate();
  const { classes } = useStyles();
  const { mobileView } = useMediaQuery();

  const handleNavigate = useCallback(() => {
    navigate(PATH_INDEX);
  }, []);

  return (
    <div className={classes.container}>
      <div className={classes.wrap}>
        <Typography variant={mobileView ? 'h2' : 'h1'}>
          Page not found
        </Typography>
        <Typography variant="subtitle1">
          This page doesn&apos;t exist, please try again
        </Typography>
        <Button
          onClick={handleNavigate}
          size={mobileView ? Size.Small : Size.Medium}
        >
          Home
        </Button>
      </div>
    </div>
  );
};

export default NotFound;
